import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { isLogged } from '../utils/common';
import { connectToWebsocket } from '../actions/websocket';
import { useDispatch } from 'react-redux';
import { initializeFirebaseApp } from '../firebase';
import { AuthRedirect } from './Routes';
import { getUserProfile } from '../actions/auth';

const ProtectedLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const { websocketConnection } = useSelector((state) => state.websocket);

    useEffect(() => {
        if (isLogged() && !websocketConnection) {
            dispatch(connectToWebsocket());
        }
    }, [dispatch, websocketConnection]);

    useEffect(() => {
        if (isLogged() && newLoggedUserData) {
            initializeFirebaseApp();
        }
    }, [newLoggedUserData]);

    useEffect(() => {
        if (isLogged() && !newLoggedUserData) {
            dispatch(getUserProfile({ navigate }));
        }
    }, [newLoggedUserData, dispatch, navigate]);

    if (isLogged() && newLoggedUserData) {
        return <Outlet />;
    }

    if (!isLogged()) {
        return <AuthRedirect />
    }

    return null;

};

export default ProtectedLayout;



// Mukhtar's Room Code Is Missing, Need To Add It